import { HostSignupForm } from "@/components/HostSignupForm";

const HostProfileCompletion = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold mb-8">Complete Your Host Profile</h1>
          <p className="text-gray-600 mb-8">
            Please complete your host profile to continue. This information helps us
            better understand your role and connect you with suitable opportunities.
          </p>
          <HostSignupForm />
        </div>
      </div>
    </div>
  );
};

export default HostProfileCompletion;